import React, {Component} from 'react';
import './Avatar.css';
import {Link} from 'react-router-dom';

/**
 * Little disc showing user's profile picture
 */
class Avatar extends Component {
	render() {
		const {
			backgroundImage,
			backgroundURL,
			provider,
			className = '',
			extraClass = '',
			size = 24,
			onClick,
			title,
			link = true
		} = this.props;

		const placeholderStyle = {
			backgroundColor: '#ffffff',
			backgroundImage: `url("/img/avatarPlaceholder.png")`,
			width: size,
			height: size,
			minWidth: size,
			minHeight: size
		};

		// NEW APPROACH -- Allows non-breaking change to interface. Provider-specific
		if (provider) {
			const {
				user: {firstname},
				profile: {uniqueName, avatarImage}
			} = provider;

			const actualImage = (
				<div
					className="Avatar-image"
					title={title || firstname}
					style={{
						backgroundImage: avatarImage ? `url("/api/image/${avatarImage}")` : undefined,
						width: size,
						height: size,
						minWidth: size,
						minHeight: size
					}}
				/>
			);

			return link ? (
				<Link
					title={title || firstname}
					to={`/@${uniqueName}`}
					className={`Avatar ${className} ${extraClass}`}
					style={placeholderStyle}>
					{actualImage}
				</Link>
			) : (
				<span
					className={`Avatar ${className} ${extraClass}`}
					onClick={onClick}
					style={placeholderStyle}>
					{this.props.children}
					{actualImage}
				</span>
			);
		}

		const actualImageOLD = (
			<div
				className="Avatar-image"
				title={title}
				style={{
					backgroundImage: backgroundURL
						? `url("${backgroundURL}")`
						: backgroundImage
						? `url("/api/image/${backgroundImage}")`
						: undefined,
					width: size,
					height: size,
					minWidth: size,
					minHeight: size
				}}
			/>
		);

		// OLD bg image approach, should be removed when no longer used.
		return (
			<span className={`Avatar ${extraClass}`} onClick={onClick} style={placeholderStyle}>
				{this.props.children}
				{actualImageOLD}
			</span>
		);
	}
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/widgets/Avatar.js